$(".product_media_zoom").on("mouseover", function() {
  $(this).children(".image-zoom").css({
   transform: "scale(" + $(this).attr("data-scale") + ")" 
  });
}).on("mouseout", function() {
  $(this).children(".image-zoom").css({
   transform: "scale(1)" });
}).on("mousemove", function(e) {
  $(this).children(".image-zoom").css({
   "transform-origin":
     ((e.pageX - $(this).offset().left) / $(this).width()) * 100 +
     "% " +
     ((e.pageY - $(this).offset().top) / $(this).width()) * 100 +
     "%"
  });
}); 